import type { AiBudgetState } from "../lib/app-config/ai-budget";
import { Card } from "./ui/Card";

interface BudgetSuspendedBannerProps {
  state: AiBudgetState | null;
}

// Bannière TOUS-USAGERS (Phase C tracking dépenses IA, mini-spec §4) : le
// kill-switch serveur (`isLlmSuspended`, `_shared/budget.ts`) bloque déjà
// toute nouvelle dépense IA dès que le budget mensuel atteint 150 $/mois —
// cette bannière l'explique en clair, là où l'usager attend un traitement
// (accueil + écran de capture). Formulation exacte validée (fiche de clôture
// 21-07) : claire, sans jargon.
export function BudgetSuspendedBanner({ state }: BudgetSuspendedBannerProps) {
  if (!state?.suspended) return null;

  return (
    <Card variant="danger">
      <p className="m-0 text-small font-semibold text-red-deep">
        Traitements IA suspendus — budget mensuel atteint.
      </p>
    </Card>
  );
}
